// External libraries
import React from 'react';
import { bool, object } from 'prop-types';

// Internal modules
import { getContent } from '@/lib';
import { mapDataToProps } from './utils';
import { useMountLogging } from '@/lib/reactHooks';
import { CartDescription, CartItem, LineAmount } from './Components';
import { AnimatedContainer } from '@/components/Common/';
import {
  CartDropdownContainer,
  Group,
  NoteToBuyer,
  StyledCartDropdown,
} from './StyledComponents';

const CartDropdown = ({ cartDetails, isCartShown }) => {
  useMountLogging('CartDropdown');

  const {
    amounts,
    currencyCode,
    description,
    items,
    merchantName,
    noteToBuyer,
    isAuthOrderTransaction,
  } = mapDataToProps(cartDetails);
  const {
    discount,
    handlingFee,
    insurance,
    shipping,
    shippingDiscount,
    subtotal,
    tax,
    total,
  } = amounts;
  const lineAmounts = [
    subtotal,
    tax,
    shipping,
    insurance,
    handlingFee,
    shippingDiscount,
    discount,
  ].filter(Boolean);
  const showCartDetails = items?.length || !isAuthOrderTransaction;

  return (
    <AnimatedContainer
      data-test-id="cart-dropdown"
      isVisible={isCartShown}
      style={{ margin: '0 -18px', padding: '0px 18px' }}
    >
      <CartDropdownContainer>
        <StyledCartDropdown>
          {noteToBuyer && (
            <NoteToBuyer>
              <h3>
                {getContent('cartDropdown.noteFrom', {
                  merchant: merchantName,
                })}
              </h3>
              <span>{noteToBuyer}</span>
            </NoteToBuyer>
          )}
          {description && !noteToBuyer && (
            <CartDescription description={description} />
          )}
          {showCartDetails && (
            <div>
              {items.map((item, idx) => (
                <CartItem currencyCode={currencyCode} item={item} key={idx} />
              ))}
              <Group>
                {lineAmounts.map(({ amount, description }, idx) => (
                  <LineAmount
                    amount={amount}
                    currencyCode={currencyCode}
                    description={description}
                    key={idx}
                  />
                ))}
              </Group>
              <Group>
                {total.amount && (
                  <LineAmount
                    amount={total.amount}
                    currencyCode={currencyCode}
                    data-testid="cart-line-total"
                    description={total.description}
                  />
                )}
              </Group>
            </div>
          )}
        </StyledCartDropdown>
      </CartDropdownContainer>
    </AnimatedContainer>
  );
};

CartDropdown.propTypes = {
  cartDetails: object,
  isCartShown: bool,
};

export { CartDropdown };
